module.exports = __webpack_public_path__ + "img/gold-ingot.e70be667.svg";